<template>
	<div class="profile profile-Client">
		<div class="vx-row">
			<div class="vx-col lg:w-1/4 w-full mt-6">
				<vx-card>
					<div class="flex justify-between items-center box-top h-full">
						<div class="des">
							<b>{{income.income}} €</b>
							<p>{{ $t('income') }}</p>
						</div>
						<div class="icon h-full">
							<feather-icon icon="CreditCardIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col lg:w-1/4 w-full mt-6">
				<vx-card>
					<div class="flex justify-between items-center box-top h-full">
						<div class="des">
							<b>{{countTask.count}}</b>
							<p>{{ $t('totalOrdersCount') }}</p>
						</div>
						<div class="icon h-full">
							<feather-icon icon="FileTextIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col lg:w-1/4 w-full mt-6">
				<vx-card>
					<div class="flex justify-between items-center box-top h-full">
						<div class="des">
							<b>{{countTaskActive.count}}</b>
							<p>{{ $t('activatedOrder') }}</p>
						</div>
						<div class="icon h-full">
							<feather-icon icon="FilePlusIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col lg:w-1/2 w-full mt-6">
				<vx-card>
					<h2><b>{{ $t('profile') }}</b></h2>
					<table class="p-0">
						<tbody>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('personName') }}</td>
							<td>{{user.first_name}} {{user.last_name}}</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">E-Mail</td>
							<td>{{ user.email }}</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('additionalEmail') }}</td>
							<td>{{  user.email_secondary }}</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('phone') }}</td>
							<td>{{  user.phone }}</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('site') }}</td>
							<td>{{  user.website }}</td>
						</tr>
						<tr v-if="user.other_websites && user.other_websites.length">
							<td class="pr-4 sm:pr-10">{{ $t('otherProfiles') }}</td>
							<td>
								<router-link
								  v-for="(site, index) in user.other_websites"
								  :key="site.client_id"
								  :to="`/client/${site.client_id}`"
								>
								  {{ site.name }}{{ addComa(user.other_websites, index) }}
								</router-link>
					  		</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('sex') }}</td>
							<td>{{ $getDeep(user.gender, genders) }}</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('country') }}</td>
							<td>{{ $getDeep(user.country, countries) }}</td>
						</tr>
						<tr v-if="user.package">
							<td class="pr-4 sm:pr-10">{{ $t('workTypeName') }}</td>
							<td>{{ user.package }}</td>
						</tr>
						<tr v-if="user.package_paid_at">
							<td class="pr-4 sm:pr-10">{{ $t('packagePaid') }}</td>
							<td>{{ user.package_paid_at }}</td>
						</tr>
						<tr v-if="user.package_expiry_date">
							<td class="pr-4 sm:pr-10 ">{{ $t('packageExpiry') }}</td>
							<td>{{ user.package_expiry_date }}</td>
						</tr>

						</tbody>
					</table>
					<div class="bottom">
            <div
              class="flex justify-center chat"
              @click="openChat()"
            >
              <vs-custom-button
                size="small"
                color="#626262"
                type="flat"
                icon-pack="feather"
                icon="edit"
              >
                <feather-icon icon="MessageSquareIcon"></feather-icon>
              </vs-custom-button>
            </div>
						<router-link :to="'/client/'+$route.params.id+'/edit'">
							<vs-button>{{ $t('edit') }}</vs-button>
						</router-link>
					</div>
				</vx-card>
			</div>
			<div
				v-if="changeManagerRequest && changeManagerRequest.id"
				class="vx-col lg:w-1/2 w-full privatManager mt-6"
			>
				<vx-card>
					<h2><b>{{ $t('changingManagerRequest') }}</b></h2>
					<div class="flex flex-col justify-between h-full pb-10">
						<p>{{ changeManagerRequest.message }}</p>
						<div class="w-1/3">
							<label>{{ $t('newManager') }}</label>
							<v-select
								class="selectExample"
							  	v-model="selectedManager"
							  	label="first_name"
							  	:reduce="e=>e.id"
							  	:searchable="false"
							  	:options="managers"
							/>
						</div>
						<div>
							<vs-button
								@click="changeManager"
								color="success"
								class="mr-2"
							>{{ $t('confirm') }}</vs-button>

							<vs-button
								@click="cancelRequest"
								color="danger"
							>{{ $t('decline') }}</vs-button>
						</div>
					</div>
				</vx-card>
			</div>
			<div v-if="!!user.id" class="vx-col w-full privatManager mt-6">
				<ClientOrdersTable
					:clientId="user.id"
          ref="clientsTable"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import ClientOrdersTable from "@/components/ClientOrdersTable/ClientOrdersTable";
import vSelect from 'vue-select';
import notifier from "@/mixins/notifier";

export default {
	name: "Client",
	mixins: [notifier],
	components: {
		ClientOrdersTable,
		'v-select': vSelect,
	},
	data() {
		return {
			managers: [],
			countTask: '',
			countTaskActive: '',
			income: '',
			user: {},
			selectedManager: null,

			val: '',
			description: '',
			manager: '',
			countries: [],
			genders: [],
		}
	},
	computed: {
		changeManagerRequest() {
			return this.user.change_manager_request;
		}
	},
	methods: {
    openChat() {
      const id = this.$route.params.id
      if (!id) return
      try {
        this.$store.dispatch('getMessages',{userId: id});
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    addComa(arr, index) {
      if (arr && arr.length > 1 && arr.length !== index + 1) return ', '
      return ''
    },
		async changeManager() {
			try {
				if(this.selectedManager === null) {
					this.notifyError(this.$t('firstlySelectManager'));
					return;
				}

				const idClient = this.user.id;
				const data = {
					request_id: this.changeManagerRequest.id,
					manager_id: this.selectedManager
				};

				await this.$http.post(`/admin/client/change-manager/${idClient}`, data);
				this.changeManagerRequest.id = null;

				this.notifySuccess(this.$t('changedSuccessfully'));

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async cancelRequest() {
			try {
				const idClient = this.user.id;
				const data = {
					request_id: this.changeManagerRequest.id,
				};

				await this.$http.post(`/admin/client/change-manager-cancel/${idClient}`, data);
				this.changeManagerRequest.id = null;

				this.notifySuccess(this.$t('requestWasDeclined'));

			}catch (e) {
				this.notifyError(e.message);
			}
		},
    async getUserData(id) {
      const requests = [
        async () => {
            this.countTask = (await this.$http.get('/admin/client/get-orders-count/'+id)).data.data
        },
        async () => {
            this.countTaskActive = (await this.$http.get('/admin/client/get-orders-active-count/'+id)).data.data
        },
        async () => {
            this.income = (await this.$http.get('/admin/client/get-income/'+id)).data.data
        },
        async () => {
            this.user = (await this.$http.get('/admin/client/view/'+id)).data.data
        },
      ]

      await Promise.all(requests.map(item => item()))
    },
	},
	async created() {
    const routeId = +this.$route.params.id
		this.countries = (await this.$http.get('/settings/get-countries')).data.data
		this.genders = (await this.$http.get('/settings/get-genders')).data.data

    await this.getUserData(routeId)

		this.managers = (await this.$http.get('/admin/manager')).data.data;
	},
  async beforeRouteUpdate (to, from, next) {
    next();
    await this.getUserData(to.params.id)
    this.$refs.clientsTable.filter()
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
.vx-card__collapsible-content{
	height: 100%;
}
.vx-card__body{
	height: 100%;
	box-sizing: border-box;
}

.profile {

	.box-top{
		b{
			font-size: 18px;
		}
	}
	.icon{
		display: flex;
		align-items: center;
	}
	.feather-icon svg{
		width: 32px;
		height: 32px;
	}
	h2 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
	}

	.vx-card {
		height: 100%;
	}

	table {
		margin-bottom: 20px;
		padding-left: 15px;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					font-weight: 600;
				}
			}

		}
	}

	.privatManager {
		.photo {
			width: 150px;
			height: 150px;
			border-radius: 10px;
			overflow: hidden;
			margin: 15px 15px;


			img {
				max-width: 100%;
			}
		}
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;

    .chat {
      margin-right: 15px;
      .vs-button {
        padding: 1px 10px 1px 6px;
        width: 46px;
        &-text {
          display: flex;
          .feather-icon {
            width: 26px;
            height: 26px;
          }
        }
      }
    }
	}

	&-Client {
		.vx-card {
			padding-right: 0 !important;
		}
	}
}
//.vs-popup {
//	max-width: 400px !important;
//
//	.vs-textarea {
//		height: 100px;
//	}
//
//	&--title {
//		h3 {
//			color: $warning;
//		}
//	}
//
//	p {
//		padding: 1rem;
//	}
//
//	&--button {
//		display: flex;
//		justify-content: flex-end;
//		border-top: 1px solid #e4e4e4;
//		padding: 1rem;
//		padding-bottom: 0.5rem;
//	}
//}

</style>
